import { navigate, PageProps } from "gatsby";
import React, { FC, useEffect, useState } from "react";
import { defaultLocale, supportedLocales } from "../../i18n/config";
import { getLocalizedPath } from "../../utils/pages";
import { Button } from "../../components/buttons/button";
import { Spinner } from "../../components/spinner";
import { EntrySys, EQRResult } from "../../types/QRTypes";
import {fetchShortLink, getContent, getFile, getParentChain, useVariableQR} from "../../utils/fetch-qr-json";

export interface StandardPageProps extends PageProps<Queries.StandardPageQuery> {}

const QRPage: FC<PageProps<unknown>> = ({ location }) => {
  const { AUTO_REDIRECT } = useVariableQR();
  const code = location.pathname.split("/qr/")[1]?.replace(/\/$/, "") ?? "";
  const [locale, setLocale] = useState<string | null>(null);
  const [path, setPath] = useState<string | null>(null);

  useEffect(() => {
    const browserLanguage = navigator.language.toLowerCase();
    const browserLocale =
      supportedLocales.find((supportedLocale) => supportedLocale.toLowerCase() === browserLanguage) ??
      supportedLocales.find(
        (supportedLocale) => supportedLocale.toLowerCase().split("-")[0] === browserLanguage.split("-")[0]
      ) ??
      defaultLocale;

    setLocale(browserLocale);
  }, []);

  const getPath = async (code: string) => {
    const responeJSON = await fetchShortLink(`${code}`, locale);
    const content = getContent(responeJSON);

    switch (content.status) {
      case EQRResult.HAS_FILE: {
        const pathFound = await getFile((content.data as EntrySys).id);
        setPath(`${pathFound}`);
        break;
      }
      case EQRResult.HAS_LINK: {
        const pathFound = getParentChain(responeJSON);
        const pathLocale = getLocalizedPath(pathFound, locale);
        setPath(pathLocale);
        break;
      }
      case EQRResult.HAS_EXTERNAL_LINK: {
        setPath(`${content.data}`);
        break;
      }
      default:
        return navigate("/404");
    }
  };

  useEffect(
    function () {
      if (code && locale) {
        getPath(code);
      }
    },
    [code, locale]
  );

  const redirect = () => {
    if (path) {
      window.open(path, "_self", "noopener,noreferrer");
    }
  };

  useEffect(
    function () {
      if (path && AUTO_REDIRECT) {
        redirect();
      }
    },
    [path]
  );

  return (
    <main style={{ color: "#111", background: "#fff", minHeight: "100vh" }}>
      {AUTO_REDIRECT && (
        <div className="flex justify-center items-center h-screen flex-col">
          <Spinner size="large" className="m-10" />
          <p>Redirecting...</p>
        </div>
      )}
      {!AUTO_REDIRECT && (
        <div>
          <h1>QR</h1>
          <p>Code: {code || "missing"}</p>
          <p>Slug found: {path || "fetching"}</p>
          <Button onClick={redirect} disabled={path == null}>
            Redirect
          </Button>
        </div>
      )}
    </main>
  );
};

export default QRPage;
